// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics"; // Import analytics helpers
import { getFirestore } from "firebase/firestore";
import { getAuth } from 'firebase/auth';
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAqPbHaBgNPsO9EolmANg0iORPfnDq-aZk",
  authDomain: "houari-boumedienne-schoo-4d4c2.firebaseapp.com",
  projectId: "houari-boumedienne-schoo-4d4c2",
  storageBucket: "houari-boumedienne-schoo-4d4c2.firebasestorage.app",
  messagingSenderId: "1035562555781",
  appId: "1:1035562555781:web:a1190cfb6a57bb0db74cec"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app); // Initialize Firestore
const auth = getAuth(app);
const storage = getStorage(app); 

// Initialize Analytics only if supported
let analytics = null;
if (typeof window !== "undefined") {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}



// Export Firebase services
export { app, db, auth, storage, analytics };